import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import UsersListLayer from "../components/AdminUserListLayer";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Admin Users" />

        {/* UsersListLayer */}
        <UsersListLayer />


    </>
  );
};

export default UsersListPage; 
